/** Presencia en línea del workspace (sesión activa reciente). */

export const WORKSPACE_PRESENCE_ONLINE_MINUTES = 5;
export const WORKSPACE_PRESENCE_HEARTBEAT_MS = 60000;
export const WORKSPACE_PRESENCE_POLL_MS = 45000;

/**
 * @param {string|undefined|null} lastSeenAt ISO
 * @param {number} [windowMinutes]
 */
export function isWorkspaceUserOnline(lastSeenAt, windowMinutes = WORKSPACE_PRESENCE_ONLINE_MINUTES) {
  if (!lastSeenAt) return false;
  const seen = new Date(lastSeenAt);
  if (Number.isNaN(seen.getTime())) return false;
  const windowMs = Math.max(1, Number(windowMinutes) || WORKSPACE_PRESENCE_ONLINE_MINUTES) * 60 * 1000;
  return Date.now() - seen.getTime() <= windowMs;
}

/** @param {{ name?: string, email?: string, portal_username?: string }} row */
export function getWorkspacePresenceDisplayName(row) {
  return row?.name || row?.email || row?.portal_username || "Usuario";
}

/** @param {{ is_admin_owner?: boolean, is_buyer_tenant?: boolean, despacho_role?: string, despacho_profile?: { despacho_role?: string } }} row */
export function getWorkspacePresenceRoleLabel(row) {
  if (row?.is_admin_owner) return "Titular";
  if (row?.is_buyer_tenant) return "Comprador";
  const dr = row?.despacho_profile?.despacho_role || row?.despacho_role;
  if (dr === "supervisor") return "Administrador de equipo";
  if (dr === "consulta") return "Consulta";
  return "Auxiliar";
}

/** Auxiliares con sesión activa (excluye titular y buyer_admin). */
export function filterOnlineAuxiliaries(presenceItems = []) {
  return (presenceItems || []).filter(
    (row) =>
      row?.is_online
      && !row?.is_admin_owner
      && !row?.is_buyer_tenant,
  );
}

/** Todos los miembros del workspace con sesión activa (titular, comprador y auxiliares). */
export function filterOnlineWorkspaceMembers(presenceItems = []) {
  return (presenceItems || []).filter((row) => row?.is_online && row?.id);
}

/**
 * Separa todos los miembros del workspace (titular, comprador y auxiliares).
 * @param {object[]} presenceItems
 * @returns {{ online: object[], offline: object[] }}
 */
export function partitionWorkspacePresence(presenceItems = []) {
  const online = [];
  const offline = [];
  for (const row of presenceItems || []) {
    if (!row?.id) continue;
    if (row.is_online) online.push(row);
    else offline.push(row);
  }
  return { online, offline };
}
